import { useEffect, useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Row, Col, Spin } from "antd";

import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import Sider from "../Components/Courses/Sider";
import Context from "../Context/context";

const ProtectedLayout = () => {
  const { state } = useContext(Context);
  const { isLoggedIn, manualRefresh } = state;

  if (manualRefresh) {
    return (
      <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',     
        width: '100vw'       
      }}
    >
        <Spin size="large" />
      </div>
    );
  }

  if (!isLoggedIn && !manualRefresh) {
    return <Navigate to="/login" replace />;
  }

  return (
   <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Header />
      <div style={{ flex: 1 }}>
        <Row>
          <Col span={4}>
            <Sider />
          </Col>
          <Col span={20}>
            <Outlet />
          </Col>
        </Row>
      </div>
      <Footer />
    </div>
  );
};

export default ProtectedLayout;
